import script from "./ruleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ruleDetail.vue?vue&type=script&setup=true&lang=js"

import "./ruleDetail.vue?vue&type=style&index=0&id=767f4a58&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-767f4a58"]])

export default __exports__